import React from "react";
import { FileText } from "lucide-react";

export const DocCountBadge = ({ count = 0, testId }) => {
    if (!count || count <= 0) return null;
    const display = count > 99 ? "99+" : String(count);
    return (
        <div
            className="relative shrink-0 w-7 h-7 rounded-sm bg-[#007AFF]/15 border border-[#00A3FF]/40 text-[#00A3FF] flex items-center justify-center"
            data-testid={testId}
            aria-label={`${count} document${count === 1 ? "" : "s"}`}
            title={`${count} document${count === 1 ? "" : "s"} attached`}
        >
            <FileText className="w-3.5 h-3.5" />
            <span
                className="absolute -top-1.5 -right-1.5 min-w-[16px] h-4 px-1 rounded-full bg-[#007AFF] text-white text-[10px] font-bold leading-none flex items-center justify-center border border-[#0A1128]"
            >
                {display}
            </span>
        </div>
    );
};

export default DocCountBadge;
